<template>
  <div
    class="Tabs"
    :value="value"
    @click="$emit('input', currentTab.value)">
    <span
      v-for="option in options"
      :key="option.name"
      class="tab"
      :class="{ active: currentTab === option }"
      @click="currentTab = option">
      {{ option.name }}
      <span
        class="count"
        v-if="option.count">
        ({{ option.count.totalCount }})
      </span>
    </span>
  </div>
  <!-- tabs -->
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      currentTab:
        this.options.filter((o) => o.value === this.value)[0] ||
        this.options[0],
    };
  },
};
</script>

<style lang="scss" scoped>
.Tabs {
  background-color: white;
  padding-bottom: 4px;

  .tab {
    cursor: pointer;
    color: var(--blue-purple);
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 5px;

    &.active {
      font-weight: bold;
      box-shadow: inset 0 -3px 0 0 #4727aa;
    }
  }
}
</style>
